import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 * @param assetModel AssetModel
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation, assetModel) {
    var url = applyPathVariables(EndPoints.SERVICE_ENTRIES_ASSET_OPEN, {
        organisationId: organisation.id,
        assetId: assetModel.getAssetSerial()
    });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true });
    return request.execute();
});
